<script setup lang="ts">
import DetailPanelSkeleton from './DetailPanelSkeleton.vue'

withDefaults(
  defineProps<{
    spinning: boolean
    /** detail | avatar-detail */
    type?: 'detail' | 'avatar-detail'
    rows?: number
    minHeight?: string
  }>(),
  {
    type: 'detail',
    rows: 6,
    minHeight: '240px',
  },
)
</script>

<template>
  <DetailPanelSkeleton
    v-if="spinning"
    :rows="rows"
    :show-avatar="type === 'avatar-detail'"
    :min-height="minHeight"
  />
  <slot v-else />
</template>
